import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Text, Truncate, getPaletteColor, SrOnly } from 'pcln-design-system'
import { Close } from 'pcln-icons'

const propTypes = {
  className: PropTypes.string,
  /** item label */
  itemText: PropTypes.string,
  /** click callback */
  onClick: PropTypes.func,
  /** filter type */
  type: PropTypes.string,
  /** filter value */
  value: PropTypes.string,
  itemFilterIcon: PropTypes.node,
  /** repeat icon number */
  repeatIconByFactor: PropTypes.number,
}

const defaultProps = {
  className: '',
  itemText: '',
  onClick: null,
}

const FilterSummaryItemWrap = styled(Button)`
  margin-right: 8px;
  margin-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  display: inline-flex;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  max-width: 226px;
  background-color: ${getPaletteColor('background.light')};
  flex-shrink: 0;
  color: inherit;
  &:hover {
    text-decoration: none;
    color: ${getPaletteColor('primary.base')};
  }
`

const ItemLabel = styled(Text.span)`
  user-select: none;
  white-space: nowrap;
`

const ItemCloseIcon = styled(Close)`
  cursor: pointer;
`

const FilterSummaryItem = ({
  className,
  itemFilterIcon,
  itemText,
  onClick,
  repeatIconByFactor = 1,
  type,
  value,
}) => {
  const icons = Array(repeatIconByFactor)
    .fill('')
    .map((el, index) => {
      return (
        itemFilterIcon &&
        typeof itemFilterIcon !== 'string' &&
        React.cloneElement(itemFilterIcon, { size: 18, key: `filter_summary_item_icon_${index}` })
      )
    })

  return (
    <FilterSummaryItemWrap variation='link' className={className} mb={2} mr={2} px={2}>
      {itemFilterIcon && icons}

      {!itemText && (
        <SrOnly>{`${repeatIconByFactor} ${itemFilterIcon}${repeatIconByFactor > 1 ? 's' : ''}`}</SrOnly>
      )}

      {itemText && (
        <Truncate>
          <ItemLabel fontSize={0} pl={1}>
            {itemText}
          </ItemLabel>
        </Truncate>
      )}

      <ItemCloseIcon
        ml={3}
        size={20}
        name={itemText}
        data-testid='close-icon'
        onClick={() => {
          onClick({
            type,
            value,
          })
        }}
      />
    </FilterSummaryItemWrap>
  )
}

FilterSummaryItem.propTypes = propTypes
FilterSummaryItem.defaultProps = defaultProps

export default FilterSummaryItem
